<template>
    <div class="">
        <banner type="2"></banner>
        <div class="w-1200" style="padding-bottom: 200px;">
            <div style="margin-top: 60px;" class="flex">
                <img src="../assets/img/guanyuwomen.jpg" width="450" alt="">
                <div class="font-500" style="margin-left: 60px;">
                    <div class="font-24 mt-5">诚信为本 质量至上</div>
                    <div class="mt-6">以自己的品牌特色和优势促进我国IVD产业质量提升、成本降低，</div>
                    <div class="mt-4">增强我国核心原料产品的市场竞争力</div>
                </div>
            </div>
            <div class="mt-8" v-html="about.content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'aboutUs',
        props: {},
        data() {
            return {
                about: {}
            }
        },
        async mounted() {
            this.getAbout()
        },
        methods: {
            async getAbout() {
                this.about = await this.$api.getAbout()
            },

        },

    }
</script>
<style scoped lang="scss">
    .nav {
        height: 100px;
        width: 100%

    }

    /deep/ img {
        max-width: 100%;
    }
</style>
